/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  Button,
  Container,
  Grid,
  Dropdown,
  Divider,
  Icon,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { decodeSearch } from '../../../utils/url';
import { translateModels } from '../../../utils/translation';
import LoadImage from '../../../components/LoadImage';
import NavBar from '../../../components/NavBar';
import LoanAmount from '../../../components/LoanAmount';
import CurrencySymbol from '../../../components/CurrencySymbol';
import { flashErrorMessage } from '../../../actions/flash';
import { fetchM } from '../../../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { getAreaLabel, getAreaModelLabel } from '../../../utils/areaLabel';
import { isCountryVietnam } from '../../../constants/countries';
import { layoutAreaValue, layoutLandAreaValue } from '../../../utils/unitLayout';

class CompareLayouts extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    data: PropTypes.shape({
      maOwnerCompanyBranchID: PropTypes.number,
    }),
    datas: PropTypes.oneOfType([PropTypes.array]).isRequired,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const layoutIdFromUrl = props.router.location.query.layoutID || '';
    const loading = props.loading;
    const isMobile = window.innerWidth < 768;
    const isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
    const count = props.count;
    const limit = props.limit;
    const offset = props.offset;
    const data = props.data || [];
    const datas = props.datas || [];
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const menuIsTab = window.innerWidth <= 590;
    return {
      data,
      datas,
      isMobile,
      loading,
      count,
      limit,
      offset,
      currentPage,
      menuIsTab,
      layoutIdFromUrl,
      isMediumScreen,
    };
  }
  constructor(props) {
    super(props);
    const state = CompareLayouts.getPropsToState(props);
    this.state = {
      ...state,
      selectedLayout: {},
      unitLowestPrice: [],
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const { layoutIdFromUrl } = this.state;
    const state = CompareLayouts.getPropsToState(nextProps);
    this.setState({ ...state });
    this.fetchProjectUnitLowestPrice();


    // set initial selected layout unit id
    if (this.state && this.state.data && this.state.data.unitLayouts) {
      const selectedLayout = {};
      const getFilteredUnitLayouts = this.state.data.unitLayouts.filter(item => item.id !== layoutIdFromUrl);

      getFilteredUnitLayouts.forEach((unit, idx) => {
        if (unit.id !== layoutIdFromUrl) {
          const result = {
            [`selectLayout${idx + 2}`]: unit.id,
          };
          Object.assign(selectedLayout, result);
        }
      });
      this.setState({
        selectedLayout: {
          selectLayout1: layoutIdFromUrl || '',
          ...selectedLayout,
        },
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  getOptionData = (data) => {
    if (data) {
      const DpOptions = data.map(unit => ({
        text: unit.name,
        value: unit.id,
      }));
      return DpOptions;
    }
    return null;
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchProjectUnitLowestPrice() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/units/units_price/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        this.setState({ unitLowestPrice: json });
      }
    }
    await this.setLoading(false);
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
    if (isMediumScreen !== this.state.isMediumScreen) {
      this.setState({ isMediumScreen });
    }
  }
  handleOnChange = (event, { value, name }) => {
    const { selectedLayout } = this.state;
    selectedLayout[name] = value;
    this.setState({ selectedLayout });
  }
  renderDropdown = () => {
    const { data, selectedLayout, isMobile, isMediumScreen } = this.state;
    const { t } = this.props;
    const unitLayouts = data.unitLayouts;
    if (unitLayouts) {
      return (
        <Grid.Row
          centered
          columns={
            isMobile ? 2
            : unitLayouts.length >= 3 ?
                isMediumScreen ?
                2 : 3
              : 2
          }
        >
          <Grid.Column>
            <Dropdown
              placeholder={t('Select {{title}}', { title: t('Layout') })}
              name="selectLayout1"
              fluid
              selection
              value={typeof selectedLayout.selectLayout1 === 'object' ? selectedLayout.selectLayout1.id : selectedLayout.selectLayout1}
              options={this.getOptionData(unitLayouts)}
              onChange={(event, value) => this.handleOnChange(event, value)}
            />
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              placeholder={t('Select {{title}}', { title: t('Layout') })}
              name="selectLayout2"
              fluid
              selection
              value={typeof selectedLayout.selectLayout2 === 'object' ? selectedLayout.selectLayout2.id : selectedLayout.selectLayout2}
              options={this.getOptionData(unitLayouts)}
              onChange={(event, value) => this.handleOnChange(event, value)}
            />
          </Grid.Column>
          {
            unitLayouts.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                <Dropdown
                  placeholder={t('Select {{title}}', { title: t('Layout') })}
                  name="selectLayout3"
                  fluid
                  selection
                  value={typeof selectedLayout.selectLayout3 === 'object' ? selectedLayout.selectLayout3.id : selectedLayout.selectLayout3}
                  options={this.getOptionData(unitLayouts)}
                  onChange={(event, value) => this.handleOnChange(event, value)}
                />
              </Grid.Column>
            : null
          }
        </Grid.Row>
      );
    }
    return null;
  }
  renderPriceRow = () => {
    const { data, selectedLayout, isMobile, unitLowestPrice, isMediumScreen } = this.state;
    const { t } = this.props;
    const unitLayouts = data.unitLayouts;
    const { selectLayout1, selectLayout2, selectLayout3 } = selectedLayout;
    const getLowestUnitPrice1 = unitLowestPrice && selectLayout1 ? unitLowestPrice.find(p => p.id === selectLayout1.id) : null;
    const getLowestUnitPrice2 = unitLowestPrice && selectLayout2 ? unitLowestPrice.find(p => p.id === selectLayout2.id) : null;
    const getLowestUnitPrice3 = unitLowestPrice && selectLayout3 ? unitLowestPrice.find(p => p.id === selectLayout3.id) : null;
    if (selectLayout1 && unitLowestPrice) {
      return (
        <Grid.Row
          centered
          columns={
            isMobile ? 2
            : unitLayouts.length >= 3 ?
                isMediumScreen ?
                2 : 3
              : 2
          }
          className="sizeRow"
        >
          <Divider horizontal>{t('Price')}</Divider>
          <Grid.Column verticalAlign="middle">
            {
              getLowestUnitPrice1 && getLowestUnitPrice1.min_price ?
                <div>
                  <h1>
                    <LoanAmount
                      format="0,000,000"
                      amount={getLowestUnitPrice1.min_price || 0}
                      prefix={<CurrencySymbol />}
                    />
                  </h1>
                  <small>{t('Starting from')}</small>
                </div>
              : <p className="noValue">{t('No {{title}} available', { title: t('Price').toLowerCase() })}</p>
            }
          </Grid.Column>
          <Grid.Column>
            {
              getLowestUnitPrice2 && getLowestUnitPrice2.min_price ?
                <div>
                  <h1>
                    <LoanAmount
                      format="0,000,000"
                      amount={getLowestUnitPrice2.min_price || 0}
                      prefix={<CurrencySymbol />}
                    />
                  </h1>
                  <small>{t('Starting from')}</small>
                </div>
              : <p className="noValue">{t('No {{title}} available', { title: t('Price').toLowerCase() })}</p>
            }
          </Grid.Column>
          {
              unitLayouts.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    getLowestUnitPrice3 && getLowestUnitPrice3.min_price ?
                      <div>
                        <h1>
                          <LoanAmount
                            format="0,000,000"
                            amount={getLowestUnitPrice3.min_price || 0}
                            prefix={<CurrencySymbol />}
                          />
                        </h1>
                        <small>{t('Starting from')}</small>
                      </div>
                : <p className="noValue">{t('No {{title}} available', { title: t('Price').toLowerCase() })}</p>
                  }
                </Grid.Column>
              : null
            }
        </Grid.Row>
      );
    }
    return (
      <Grid.Row centered columns={isMobile ? 2 : 3} className="sizeRow">
        <Divider horizontal>{t('Price')}</Divider>
      </Grid.Row>
    );
  }
  renderSpecRow = () => {
    const { data, selectedLayout, isMobile, isMediumScreen } = this.state;
    const { t } = this.props;
    const unitLayouts = data.unitLayouts;
    const { selectLayout1, selectLayout2, selectLayout3 } = selectedLayout;

    // check layout spec has bed field
    const checkLayout1Bed = selectLayout1 && selectLayout1.specifications ? selectLayout1.specifications.some(spec => spec.shortName === 'Bed') : '';
    const checkLayout2Bed = selectLayout2 && selectLayout2.specifications ? selectLayout2.specifications.some(spec => spec.shortName === 'Bed') : '';
    const checkLayout3Bed = selectLayout3 && selectLayout3.specifications ? selectLayout3.specifications.some(spec => spec.shortName === 'Bed') : '';

    // check layout spec has bath field
    const checkLayout1Bath = selectLayout1 && selectLayout1.specifications ? selectLayout1.specifications.some(spec => spec.shortName === 'Bath') : '';
    const checkLayout2Bath = selectLayout2 && selectLayout2.specifications ? selectLayout2.specifications.some(spec => spec.shortName === 'Bath') : '';
    const checkLayout3Bath = selectLayout3 && selectLayout3.specifications ? selectLayout3.specifications.some(spec => spec.shortName === 'Bath') : '';

    // check layout spec has car field
    const checkLayout1Car = selectLayout1 && selectLayout1.specifications ? selectLayout1.specifications.some(spec => spec.shortName === 'Car') : '';
    const checkLayout2Car = selectLayout2 && selectLayout2.specifications ? selectLayout2.specifications.some(spec => spec.shortName === 'Car') : '';
    const checkLayout3Car = selectLayout3 && selectLayout3.specifications ? selectLayout3.specifications.some(spec => spec.shortName === 'Car') : '';

    return (
      <Grid.Row
        centered
        columns={
          isMobile ? 2
          : unitLayouts.length >= 3 ?
              isMediumScreen ?
              2 : 3
            : 2
        }
        className="spec_row"
      >
        <Divider horizontal>{t('Specifications')}</Divider>
        <Grid.Column>
          {
            selectLayout1 &&
            selectLayout1.specifications &&
            checkLayout1Bed ?
              selectLayout1.specifications.map((spec, idx) => (
                spec.name.toLowerCase() === 'bedrooms' ?
                  <div className="specColumns" key={idx}>
                    <h1>
                      {
                        isNaN(spec.value) ?
                        ''
                        : <small>x</small>
                      }
                      {spec.value || '0'}
                    </h1>
                    <Icon name="bed" />
                    <p>{t('Bedrooms')}</p>
                    <br />
                  </div>
                : null
              ))
            : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Bedrooms').toLowerCase() })}</p>
          }
        </Grid.Column>
        <Grid.Column>
          {
            selectLayout2 &&
            selectLayout2.specifications &&
            checkLayout2Bed ?
              selectLayout2.specifications.map((spec, idx) => (
                spec.name.toLowerCase() === 'bedrooms' ?
                  <div className="specColumns" key={idx}>
                    <h1>
                      {
                        isNaN(spec.value) ?
                        ''
                        : <small>x</small>
                      }
                      {spec.value || '0'}
                    </h1>
                    <Icon name="bed" />
                    <p>{t('Bedrooms')}</p>
                    <br />
                  </div>
                : null
              ))
            : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Bedrooms').toLowerCase() })}</p>

          }
        </Grid.Column>
        {
            unitLayouts.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectLayout3 &&
                  selectLayout3.specifications &&
                  checkLayout3Bed ?
                    selectLayout3.specifications.map((spec, idx) => (
                      spec.name.toLowerCase() === 'bedrooms' ?
                        <div className="specColumns" key={idx}>
                          <h1>
                            {
                              isNaN(spec.value) ?
                              ''
                              : <small>x</small>
                            }
                            {spec.value || '0'}
                          </h1>
                          <Icon name="bed" />
                          <p>{t('Bedrooms')}</p>
                          <br />
                        </div>
                      : null
                    ))
                  : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Bedrooms').toLowerCase() })}</p>

                }
              </Grid.Column>
              : null
        }
        <Grid.Column>
          {
            selectLayout1 &&
            selectLayout1.specifications &&
            checkLayout1Bath ?
              selectLayout1.specifications.map((spec, idx) => (
                spec.name.toLowerCase() === 'bathrooms' ?
                  <div className="specColumns" key={idx}>
                    <h1>
                      {
                        isNaN(spec.value) ?
                        ''
                        : <small>x</small>
                      }
                      {spec.value || '0'}
                    </h1>
                    <Icon name="bath" />
                    <p>{t('Bathrooms')}</p>
                    <br />
                  </div>
                : null
              ))
            : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Bathrooms').toLowerCase() })}</p>
          }
        </Grid.Column>
        <Grid.Column>
          {
            selectLayout2 &&
            selectLayout2.specifications &&
            checkLayout2Bath ?
              selectLayout2.specifications.map((spec, idx) => (
                spec.name.toLowerCase() === 'bathrooms' ?
                  <div className="specColumns" key={idx}>
                    <h1>
                      {
                        isNaN(spec.value) ?
                        ''
                        : <small>x</small>
                      }
                      {spec.value || '0'}
                    </h1>
                    <Icon name="bath" />
                    <p>{t('Bathrooms')}</p>
                    <br />
                  </div>
                : null
              ))
            : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Bathrooms').toLowerCase() })}</p>
          }
        </Grid.Column>
        {
            unitLayouts.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectLayout3 &&
                  selectLayout3.specifications &&
                  checkLayout3Bath ?
                    selectLayout3.specifications.map((spec, idx) => (
                      spec.name.toLowerCase() === 'bathrooms' ?
                        <div className="specColumns" key={idx}>
                          <h1>
                            {
                              isNaN(spec.value) ?
                              ''
                              : <small>x</small>
                            }
                            {spec.value || '0'}
                          </h1>
                          <Icon name="bath" />
                          <p>{t('Bathrooms')}</p>
                          <br />
                        </div>
                      : null
                    ))
                  : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Bathrooms').toLowerCase() })}</p>
                }
              </Grid.Column>
              : null
          }

        <Grid.Column>
          {
            selectLayout1 &&
            selectLayout1.specifications &&
            checkLayout1Car ?
              selectLayout1.specifications.map((spec, idx) => (
                spec.name.toLowerCase() === 'parking lots' ?
                  <div className="specColumns" key={idx}>
                    <h1>
                      {
                        isNaN(spec.value) ?
                        ''
                        : <small>x</small>
                      }
                      {spec.value || '0'}
                    </h1>
                    <Icon name="car" />
                    <p>{t('Parking Lots')}</p>
                    <br />
                  </div>
                : null
              ))
            : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Parking Lots').toLowerCase() })}</p>
          }
        </Grid.Column>
        <Grid.Column>
          {
            selectLayout2 &&
            selectLayout2.specifications &&
            checkLayout2Car ?
              selectLayout2.specifications.map((spec, idx) => (
                spec.name.toLowerCase() === 'parking lots' ?
                  <div className="specColumns" key={idx}>
                    <h1>
                      {
                        isNaN(spec.value) ?
                        ''
                        : <small>x</small>
                      }
                      {spec.value || '0'}
                    </h1>
                    <Icon name="car" />
                    <p>{t('Parking Lots')}</p>
                    <br />
                  </div>
                : null
              ))
            : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Parking Lots').toLowerCase() })}</p>
          }
        </Grid.Column>
        {
            unitLayouts.length >= 3 && !isMobile ?
              <Grid.Column only="computer">
                {
                  selectLayout3 &&
                  selectLayout3.specifications &&
                  checkLayout3Car ?
                    selectLayout3.specifications.map((spec, idx) => (
                      spec.name.toLowerCase() === 'parking lots' ?
                        <div className="specColumns" key={idx}>
                          <h1>
                            {
                              isNaN(spec.value) ?
                              ''
                              : <small>x</small>
                            }
                            {spec.value || '0'}
                          </h1>
                          <Icon name="car" />
                          <p>{t('Parking Lots')}</p>
                          <br />
                        </div>
                      : null
                    ))
                  : <p className="noSpecAvailable">{t('No {{title}} available', { title: t('Parking Lots').toLowerCase() })}</p>
                }
              </Grid.Column>
            : null
          }
      </Grid.Row>
    );
  }
  renderContent = () => {
    const { data, selectedLayout, isMobile, isMediumScreen } = this.state;
    const { t } = this.props;
    const countryCode = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode;
    // CPI-1208 post-fix: a Vietnamese layout is compared on NSA and NFA; the old Size / Land Area
    // pair is not shown at all. The first divider already reads "NSA - Net Saleable Area" for
    // Vietnam (getAreaModelLabel), so only the second label and the six values move.
    const isVietnam = isCountryVietnam(countryCode);
    const landAreaModelLabel = isVietnam ?
      translateModels(t, 'nfa', 'projectUnitLayout') :
      translateModels(t, 'landArea', 'projectUnitLayout');
    const landAreaEmptyTitle = isVietnam ?
      translateModels(t, 'nfa', 'projectUnitLayout') : t('unit land area');
    const unitLayouts = data.unitLayouts;
    Object.keys(selectedLayout).forEach((key) => {
      unitLayouts.filter((unit) => {
        if (unit.id === selectedLayout[key]) {
          selectedLayout[key] = unit;
          return unit;
        }
        return null;
      });
    });
    const { selectLayout1, selectLayout2, selectLayout3 } = selectedLayout;
    if (unitLayouts && selectedLayout) {
      return (
        <Grid centered columns={2} className="compare_content">
          <Grid.Row
            centered
            columns={
              isMobile ? 2
              : unitLayouts.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
          >
            <Grid.Column>
              {
                selectLayout1 ?
                  <LoadImage
                    fluid
                    cover="vertical long"
                    centered
                    loading={this.state.loading}
                    notFoundNode={
                      <div>
                        <p>{t('No cover picture found')}.</p>
                        <Button
                          as={Link}
                          primary compact
                          disabled={this.state.loading}
                          to={`/projects/${this.props.id}/layouts/${selectLayout1.id}/pictures/`}
                          content={t('Click here to add')}
                        />
                      </div>
                    }
                    picture={
                      selectLayout1.pictures ?
                      selectLayout1.pictures.find((pic) => {
                        if (pic.type === 'unit_layout') {
                          return pic.key;
                        }
                        return null;
                      })
                    : null
                  }
                    pictureSize={100}
                  />
                : null
              }
            </Grid.Column>
            <Grid.Column>
              {
                selectLayout2 ?
                  <LoadImage
                    fluid
                    cover="vertical long"
                    centered
                    loading={this.state.loading}
                    notFoundNode={
                      <div>
                        <p>{t('No cover picture found')}.</p>
                        <Button
                          as={Link}
                          primary compact
                          disabled={this.state.loading}
                          to={`/projects/${this.props.id}/layouts/${selectLayout2.id}/pictures/`}
                          content={t('Click here to add')}
                        />
                      </div>
                    }
                    picture={
                      selectLayout2.pictures ?
                      selectLayout2.pictures.find((pic) => {
                        if (pic.type === 'unit_layout') {
                          return pic.key;
                        }
                        return null;
                      })
                      : null
                    }
                    pictureSize={100}
                  />
                : null
              }
            </Grid.Column>
            {
                unitLayouts.length >= 3 && !isMobile ?
                  <Grid.Column only="computer">
                    {
                      selectLayout3 ?
                        <LoadImage
                          fluid
                          centered
                          cover="vertical long"
                          loading={this.state.loading}
                          notFoundNode={
                            <div>
                              <p>{t('No cover picture found')}.</p>
                              <Button
                                as={Link}
                                primary compact
                                disabled={this.state.loading}
                                to={`/projects/${this.props.id}/layouts/${selectLayout3.id}/pictures/`}
                                content={t('Click here to add')}
                              />
                            </div>
                          }
                          picture={
                            selectLayout3.pictures ?
                            selectLayout3.pictures.find((pic) => {
                              if (pic.type === 'unit_layout') {
                                return pic.key;
                              }
                              return null;
                            })
                            : null
                          }
                          pictureSize={100}
                        />
                    : null
                  }
                  </Grid.Column>
                : null
              }
          </Grid.Row>

          {this.renderPriceRow()}

          <Grid.Row
            centered
            columns={
              isMobile ? 2
              : unitLayouts.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
            className="sizeRow"
          >
            <Divider horizontal>{getAreaModelLabel(t, countryCode)}</Divider>
            <Grid.Column>
              {
                selectLayout1 &&
                layoutAreaValue(isVietnam, selectLayout1) ?
                  <div>
                    <h1>{layoutAreaValue(isVietnam, selectLayout1) || 0}</h1>
                    {
                      data.sizeSuffix === 'square_feet' ?
                        <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                      : data.sizeSuffix === 'square_metres' ?
                        <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                        : ''
                    }
                  </div>
            : <p className="noValue">{t('No {{title}} available', { title: getAreaLabel(t, countryCode, { lower: true }) })}</p>
          }
            </Grid.Column>
            <Grid.Column>
              {
                selectLayout2 &&
                layoutAreaValue(isVietnam, selectLayout2) ?
                  <div className="sizeRow">
                    <h1>{layoutAreaValue(isVietnam, selectLayout2) || 0}</h1>
                    {
                      data.sizeSuffix === 'square_feet' ?
                        <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                      : data.sizeSuffix === 'square_metres' ?
                        <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                        : ''
                    }
                  </div>
                : <p className="noValue">{t('No {{title}} available', { title: getAreaLabel(t, countryCode, { lower: true }) })}</p>
              }
            </Grid.Column>
            {
              unitLayouts.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectLayout3 &&
                    layoutAreaValue(isVietnam, selectLayout3) ?
                      <div className="sizeRow">
                        <h1>{layoutAreaValue(isVietnam, selectLayout3) || 0}</h1>
                        {
                          data.sizeSuffix === 'square_feet' ?
                            <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                          : data.sizeSuffix === 'square_metres' ?
                            <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                            : ''
                        }
                      </div>
                    : <p className="noValue">{t('No {{title}} available', { title: getAreaLabel(t, countryCode, { lower: true }) })}</p>
                  }
                </Grid.Column>
              : null
            }
          </Grid.Row>


          <Grid.Row
            centered
            columns={
              isMobile ? 2
              : unitLayouts.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
            className="sizeRow"
          >
            <Divider horizontal>{landAreaModelLabel}</Divider>
            <Grid.Column>
              {
                selectLayout1 &&
                layoutLandAreaValue(isVietnam, selectLayout1) ?
                  <div>
                    <h1>{layoutLandAreaValue(isVietnam, selectLayout1) || 0}</h1>
                    {
                      data.sizeSuffix === 'square_feet' ?
                        <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                      : data.sizeSuffix === 'square_metres' ?
                        <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                        : ''
                    }
                  </div>
                : <p className="noValue">{t('No {{title}} available', { title: landAreaEmptyTitle })}</p>
              }
            </Grid.Column>
            <Grid.Column>
              {
                selectLayout2 &&
                layoutLandAreaValue(isVietnam, selectLayout2) ?
                  <div className="sizeRow">
                    <h1>{layoutLandAreaValue(isVietnam, selectLayout2) || 0}</h1>
                    {
                      data.sizeSuffix === 'square_feet' ?
                        <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                      : data.sizeSuffix === 'square_metres' ?
                        <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                        : ''
                    }
                  </div>
                : <p className="noValue">{t('No {{title}} available', { title: landAreaEmptyTitle })}</p>
              }
            </Grid.Column>
            {
              unitLayouts.length >= 3 && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectLayout3 &&
                    layoutLandAreaValue(isVietnam, selectLayout3) ?
                      <div className="sizeRow">
                        <h1>{layoutLandAreaValue(isVietnam, selectLayout3) || 0}</h1>
                        {
                          data.sizeSuffix === 'square_feet' ?
                            <small>{t('sqft', { ns: TRANSLATION_FILES.screens })}</small>
                          : data.sizeSuffix === 'square_metres' ?
                            <small>{isVietnam ? 'm²' : t('sqm', { ns: TRANSLATION_FILES.screens })}</small>
                            : ''
                        }
                      </div>
                    : <p className="noValue">{t('No {{title}} available', { title: landAreaEmptyTitle })}</p>
                  }
                </Grid.Column>
              : null
            }
          </Grid.Row>

          <Grid.Row
            centered
            columns={
              isMobile ? 2
              : unitLayouts.length >= 3 ?
                  isMediumScreen ?
                  2 : 3
                : 2
            }
          >
            <Divider horizontal>{t('Units')}</Divider>
            <Grid.Column>
              {
                selectLayout1 && selectLayout1.summary ?
                selectLayout1.summary.newUnits || selectLayout1.summary.totalUnits ?
                  <div>
                    <h1>{selectLayout1.summary.newUnits || '0'}</h1>
                    <small>{t('Available', { ns: TRANSLATION_FILES.constants })}</small>
                    <br />
                    <h1 className="row-margin">{selectLayout1.summary.totalUnits || '0'}</h1>
                    <small>{t('Total')}</small>
                  </div>
                  : <p className="mulitNoValue">{t('No {{title}} available', { title: t('Unit').toLowerCase() })}</p>
                : <p className="mulitNoValue">{t('No {{title}} available', { title: t('Unit').toLowerCase() })}</p>
              }
            </Grid.Column>
            <Grid.Column>
              {
                selectLayout2 && selectLayout2.summary ?
                      selectLayout2.summary.newUnits || selectLayout2.summary.totalUnits ?
                        <div className="sizeRow">
                          <h1>{selectLayout2.summary.newUnits || '0'}</h1>
                          <small>{t('Available', { ns: TRANSLATION_FILES.constants })}</small>
                          <br />
                          <h1 className="row-margin">{selectLayout2.summary.totalUnits || '0'}</h1>
                          <small>{t('Total')}</small>
                        </div>
                      : <p className="mulitNoValue">{t('No {{title}} available', { title: t('Unit').toLowerCase() })}</p>
                : <p className="mulitNoValue">{t('No {{title}} available', { title: t('Unit').toLowerCase() })}</p>
              }
            </Grid.Column>
            {
              unitLayouts.length >= 3 && selectLayout3 && selectLayout3.summary && !isMobile ?
                <Grid.Column only="computer">
                  {
                    selectLayout3.summary.newUnits || selectLayout3.summary.totalUnits ?
                      <div className="sizeRow">
                        <h1>{selectLayout3.summary.newUnits || '0'}</h1>
                        <small>{t('Available', { ns: TRANSLATION_FILES.constants })}</small>
                        <br />
                        <h1 className="row-margin">{selectLayout3.summary.totalUnits || '0'}</h1>
                        <small>{t('Total')}</small>
                      </div>
                    : <p className="mulitNoValue">{t('No {{title}} available', { title: t('Unit').toLowerCase() })}</p>
                  }
                </Grid.Column>
              : null
            }
          </Grid.Row>
          {this.renderSpecRow()}
        </Grid>
      );
    }
    return null;
  }
  render() {
    const { data, isMobile } = this.state;
    const { unitLayouts } = data;
    const { t } = this.props;
    return (
      <Container>
        <NavBar />
        <Grid columns={2}>
          <Grid.Row
            centered
            columns={
              isMobile ? 2
              : unitLayouts ? unitLayouts.length >= 3 ?
                  3 : 2
                : null
            }
            className="compare_header"
          >
            <h4>{t('Compare Layouts')}</h4>
            {
              data && data.name ?
                <p>{data.name}</p>
              : ''
            }
          </Grid.Row>
          {this.renderDropdown()}
        </Grid>
        {this.renderContent()}
      </Container>
    );
  }
}

export default  withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.projectUnitLayout,
])(connect(CompareLayouts.mapStateToProps)(CompareLayouts));



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayouts/Compare.jsx